import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-rouble-icon',
  templateUrl: './shopping-rouble.component.html'
})
export class ShoppingRoubleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
